module.exports = __webpack_public_path__ + "static/media/user-block.c1a0afcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/user-block.jpg
// module id = 1920
// module chunks = 0